import React from 'react';
import PropTypes from 'prop-types';
import { profileUrl } from '../../helpers/urlBuilder';
import Svg from 'rp-react-svg-icon';

/**
 * Table cell with link to horse / human profile
 *
 * @param {{}} props
 * @constructor
 */
const ProfileCell = (props) => {
    if (!props.rowData[props.customCell.options.columnUid] || !props.rowData[props.columnName]) {
        return (
            <span
                className={props.customCell.options.className}
            >
                {props.rowData[props.columnName]}
            </span>
        );
    }

    return (
        <a
            href={profileUrl(
            props.customCell.options.profileType,
            props.rowData[props.customCell.options.columnUid],
            (
                props.customCell.options.columnStyleName
                    ? props.rowData[props.customCell.options.columnStyleName]
                    : props.rowData[props.columnName]
            )
        )}
            className="js-popupLink ui-link ui-link_table"
        >
            <span
                className={props.customCell.options.className}
            >
                {props.rowData[props.columnName]}
            </span>
            {(() => {
                const shortNameOptions = props.customCell.options.shortName;
                if (shortNameOptions) {
                    return (
                        <span
                            className={shortNameOptions.className}
                        >
                            {props.rowData[shortNameOptions.column]}
                        </span>
                    );
                }
                return '';
            })()}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </a>
    );
};

ProfileCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default ProfileCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/ProfileCell.js